import { makeAutoObservable } from 'mobx'
import { GrantAIAgent } from '../agent/grant-ai-agent'
import { ExecuteAgentDto } from '../../entity/dto/execute-agent-dto'

export default class GrantAIStore {
  grantAIAgent: GrantAIAgent;

  constructor(grantAIAgent: GrantAIAgent) {
    makeAutoObservable(this);
    this.grantAIAgent = grantAIAgent;
  }

  executeAgent = async (organizationId: string, executeAgentDto: ExecuteAgentDto): Promise<any> => {
    try {
      const requestBody = { body: executeAgentDto };
      return await this.grantAIAgent.executeAgent(organizationId, requestBody);
    } catch (error: any) {
      console.error('Error occurred while execute agent. Please try again in while !!', error);
      return 'Error occurred while execute agent. Please try again in while !!';
    }
  }
}
